import { combineReducers } from 'redux-immutable';

import DataReducer from './DataReducer/DataReducer';
import { BaseDataStore } from './DataReducer/DataReducer.types';
import FiltersReducer from './FiltersReducer/FiltersReducer';
import { BaseFiltersStore } from './FiltersReducer/FiltersReducer.types';

export const EventsReducer = combineReducers<BaseEventsStoreElement>({
  data: DataReducer,
  filter: FiltersReducer,
});

export interface BaseEventsStore {
  events: BaseEventsStoreElement;
}

export interface BaseEventsStoreElement {
  data: BaseDataStore;
  filter: BaseFiltersStore;
}
